// --------------------------------------------------------
// SCREEN HEADER - ScreenHeader
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useEffect } from "react";
import Colors from "../../../constants/Colors";
import useResponsiveInfo from "../../../hooks/useResponsiveInfo";
import { Container } from "../../../pages/company/companyRegister/CompanyRegister.styled";
import ErrorArea from "../../error/ErrorArea";
import { ButtonMarkConsulta } from "../../../pages/collaboratorInitial/CollaboratorInitial.styled";
import { H1 } from "../generalLayout/Layout.styled";
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// SCREEN HEADER INTERFACE
// --------------------------------------------------------

interface IScreenHeaderWithButton {
  screenTitle: string;
  rightButtonText: string;
  onRightButtonClick: any;
  hasRightButton?: boolean;
  errors?: any[];
  onCloseError?: any;
  showIcon?: boolean;
  rightButtonIcon?: any;
  loading?: boolean;
}

/**
/**
 * A component that renders a Screen Header.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const ScreenHeader = ({
  screenTitle,
  errors = [],
  onCloseError = undefined,
  hasRightButton = true,
  rightButtonText,
  onRightButtonClick,
  showIcon = false,
  rightButtonIcon,
  loading = false,
}: IScreenHeaderWithButton) => {
  // --------------------------------------------------------
  // SCREEN HEADER PRIVATE DECLARATIONS
  // --------------------------------------------------------
  const { isMobile } = useResponsiveInfo();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0 });
  }, []);

  // --------------------------------------------------------

  // --------------------------------------------------------
  // REACT RETURN FUNCTION
  // --------------------------------------------------------
  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          width: "100%",
          justifyContent: "space-between",
          alignItems: isMobile ? "flex-start" : "center",
          gap: "16px",
          marginBottom: "24px",
          marginTop: 0,
        }}
      >
        <H1 style={{ color: "#0F172A", fontWeight: 700, fontSize: "22px", display: "flex", alignItems: "center", gap: "10px", margin: 0 }}>
          <span style={{ width: 4, height: 22, background: "#0A5190", borderRadius: 2, display: "inline-block" }}></span>
          <span>{screenTitle}</span>
        </H1>

        {hasRightButton && (
          <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
            <ButtonMarkConsulta
              color="#0a5190"
              onClick={onRightButtonClick}
              disabled={loading}
              isTablet={isMobile}
            >
              {rightButtonIcon}
              {showIcon && !rightButtonIcon ? <AddCircleOutlineIcon /> : undefined}
              {rightButtonText}
            </ButtonMarkConsulta>
          </div>
        )}
      </div>
      <div style={{ marginBottom: errors && errors.length > 0 ? 20 : 0 }}>
        <ErrorArea errorList={errors} onCloseAction={onCloseError} />
      </div>
    </>
  );
  // --------------------------------------------------------
};

export default ScreenHeader;
